import type { TFunction } from 'i18next';

import i18n from 'i18n/i18n';
import type { AddressForm } from './services/conversation-preferences-service';

type StoredAddressForm = AddressForm | 'unknown' | null;

/** i18next context for du/Sie copy: the base key is the formal form and `KEY_informal` the
 *  informal one, so an unknown form reads formal. English has a single form and always reads
 *  the base key, even when the user chose du in another language. */
export const addressContext = (form?: StoredAddressForm, language: string = i18n.language) =>
  form === 'informal' && !/^en(-|$)/i.test(language ?? '') ? 'informal' : undefined;

/** English has a single form, so only de, fr and it ask how to address the user. */
export const hasAddressForms = (language?: string | null) =>
  /^(de|fr|it)(-|$)/i.test(language ?? '');

/** The saved form wins; before onboarding saved one, the local answer; formal otherwise. */
export const resolveAddressForm = (
  saved?: AddressForm | 'unknown' | null,
  local?: AddressForm | null
): AddressForm => {
  if (saved === 'formal' || saved === 'informal') return saved;
  return local ?? 'formal';
};

/** The generic retry text of the settings card and the soul editor, in the user's form. */
export const conversationFailedText = (t: TFunction, form?: AddressForm | 'unknown' | null) =>
  t('PROFILE_CONVERSATION_FAILED', {
    defaultValue: "Hang on, something's stuck. Please try again in a moment.",
    context: addressContext(form),
  });
